import { ventasApi } from '@/infra/axios'

import { AxiosAdapter } from './adapters/axios-adapter'

export const httpClient = new AxiosAdapter(ventasApi)

export { AxiosAdapter, type AxiosErrorMap } from './adapters/axios-adapter'
export { HttpService, type HttpErrorResponse } from './http-service'
